/** @jsx jsx */
import { jsx } from '@emotion/react'
import { css } from '@emotion/react/macro'

import Button, { ButtonProps } from '../Button'
import { ButtonVariant } from '../types'

type ToggleButtonProps = {
  /** Accessible label for the button */
  ariaLabel: string
  /** Indicates if the toggle/button is currently selected */
  selected?: boolean
  /** ID for the button */
  value: string
} & ButtonProps

const defaultProps: Pick<ToggleButtonProps, 'selected'> = {
  selected: undefined
}

const toggleCss = css`
  width: 100%;
  display: flex;
  align-items: inherit;
  justify-content: inherit;
`

const ToggleButton = ({ ariaLabel, children, selected, ...props }: ToggleButtonProps) => (
  <Button ariaLabel={ariaLabel} selected={selected} variant={ButtonVariant.Toggle} {...props}>
    <span css={toggleCss}>{children}</span>
  </Button>
)

ToggleButton.defaultProps = defaultProps

export default ToggleButton
